<template>
	<div
		class="ms-grid-viewer"
		:class="[
			{
				isResizeActive: isResizeActive,
				'h-auto': maxHeight,
				'hide-border-last-row-on-scroll': isHideLastRowBorderOnScroll,
			},
			gridViewClass,
		]"
	>
		<div
			class="container-filter-text"
			v-if="filterable && filterHeaders.length > 0"
		>
			<div class="container-filter">
				<div
					class="item-filter flex"
					v-for="item in filterHeaders"
					:key="item.dataField"
				>
					<div
						class="content flex"
						v-tooltip="{
							content: `${buildTitleText(item)} ${buildOperatorText(
								item.Operator
							)} ${buildValue(item)}`,
							html: true,
						}"
					>
						<div class="column">
							{{ buildTitleText(item) }}
						</div>
						<div class="operator">
							{{ buildOperatorText(item.Operator) }}
						</div>
						<div class="value" v-html="buildValue(item)"></div>
					</div>
					<div
						class="cusor-pointer mi-new-v2 mi-16 mi-icon-v2-close-16"
						@click="removeFilterItem(item)"
					></div>
				</div>
				<div class="clear-all-filter" @click="clearAllFilter">
					{{ $t('i18nComponent.HeaderOptionFilter.UnFilter') }}
				</div>
			</div>
		</div>

		<div
			v-if="isFirstFilter"
			class="ms-content--header"
			ref="header"
			:class="[
				{
					'hide-scroll': scrollVisiable,
					'ms-content--header-noborder': !isBorderTh,
				},
				classContentHeader,
			]"
		>
			<div>
				<table class="ms-table">
					<thead class="ms-thead">
						<tr class="ms-tr" :class="isBorderTh ? '' : 'ms-tr-noborder'">
							<th
								v-if="draggable"
								class="ms-th draggable-cell fix-row ms-th-bg"
							></th>
							<th
								v-if="multiple"
								class="ms-th multiple-cell fix-row ms-th-bg"
								:class="[
									{ 'grey-title': greyTitle },
									{ 'col-only-check': !widgetOptionsLeft },
									isCheckboxHasAfter ? 'ms-th-has-after' : '',
									gridOptions && gridOptions.hiddenAfterMutipleCell
										? 'hidden-after-multiple-cell'
										: '',
								]"
							>
								<ms-checkbox
									:value="isCheckedMultiple"
									@click="changeCheckedMultiple"
									class="justify-center"
									checkOnly
									:disabled="multipleDisabled"
									v-tooltip="
										tooltipCheckboxMulti
											? {
													content: tooltipCheckboxMulti,
													placement: 'top-start',
											  }
											: {}
									"
									:isLineTick="isCheckedSomeData"
								/>
							</th>
							<th
								class="ms-th serial-title"
								v-if="serial"
								:class="{ 'grey-title': greyTitle }"
							>
								{{ $t('i18nCommon.OrderNumber') }}
							</th>
							<th
								class="ms-th widget-title widget-title-left multiple-cell-widget ms-th-bg"
								v-if="widgetOptionsLeft"
								:class="[
									`text-${
										widgetOptionsLeft.align ? widgetOptionsLeft.align : 'right'
									}`,
									{ 'grey-title': greyTitle },
									{ 'fix-column-left box-sizing-default': isScrollLeft },
								]"
								:style="[
									{ 'min-width': `${widgetOptionsLeft.width}px` },
									columnx.length > 0
										? { width: `${widgetOptionsLeft.width}px` }
										: null,
								]"
							>
								<span>{{ widgetOptionsLeft.title }}</span>
							</th>
							<ms-th
								ref="th"
								class="ms-th"
								v-for="(col, index) in columnx"
								:key="col.dataField"
								:col="col"
								:resizeCol="resizeCol"
								:sortCol="sortCol"
								:truncateOverflow="truncateOverflow"
								@resizeOn="onResizeStart"
								:class="[
									{ 'grey-title': greyTitle },
									columnx && index == columnx.length - 1
										? 'ms-th-last-col'
										: '',
								]"
								@resizeOff="resizeClose"
								@sort="sort"
								:name="name"
								:sortCondition="sortCondition"
								:customGridLayout="customGridLayout"
								@onClickiconAfterTitle="onClickiconAfterTitle"
								:filterable="filterable"
								@buildFilter="buildFilterHeader"
								:filterHeaders="filterHeaders"
							></ms-th>
							<th
								class="ms-th widget-title"
								v-if="widgetOptions"
								:class="[
									`text-${widgetOptions.align ? widgetOptions.align : 'right'}`,
									{ 'grey-title': greyTitle },
								]"
								:style="[
									{ 'min-width': `${widgetOptions.width}px` },
									columnx.length > 0
										? { width: `${widgetOptions.width}px` }
										: null,
								]"
							>
								<span>{{ widgetOptions.title }}</span>
							</th>
						</tr>
					</thead>
				</table>
			</div>
		</div>
		<div
			v-if="!isFirstFilter"
			class="text-center h-full flex-box justify-center"
		>
			<div class="icon-area">
				<div class="mi-new-v2 mi-175 mi-no-data-report mb-4"></div>
			</div>
			<div class="text-nondata-area">
				{{ $t('i18nReport.SelectDateRangeReport') }}
			</div>
		</div>
		<div
			class="ms-content--table"
			:class="[hasScroll ? 'ms-content--table--scroll' : '', classContentTable]"
			@scroll="onScroll"
			:style="[gridViewStyle]"
			ref="content"
			v-else-if="!dataEmpty || shimmerLoaded === false"
		>
			<table class="ms-table" v-if="groupField">
				<tbody class="ms-tbody">
					<ms-group-tr
						v-for="(dataRow, indexRow) in datax"
						:isSelected="isSelected(dataRow)"
						:key="dataRow['__vKeyValue']"
						:columns="columnx"
						:index="indexRow"
						:dataRow="dataRow"
						:widgetOptions="widgetOptions"
						:widgetOptionsLeft="widgetOptionsLeft"
						:serial="serial"
						:pageSize="pageSize"
						:currentPage="currentPage"
						:multiple="multiple"
						:multipleDisabled="multipleDisabled"
						:draggable="draggable"
						v-on="listeners"
						:groupField="groupField"
						:loadChildrenData="loadChildrenData"
						:isGridReport="isGridReport"
					></ms-group-tr>
				</tbody>
			</table>
			<table class="ms-table" v-else>
				<transition
					name="trans-content-table"
					mode="out-in"
					v-on:before-enter="beforeRenderContent"
				>
					<draggable
						v-if="shimmerLoaded !== false && draggable"
						tag="tbody"
						:list="datax"
						handle=".draggable-icon"
						class="ms-tbody"
						:key="shimmerLoaded"
						@change="onDragChange"
					>
						<ms-tr
							ref="tr"
							v-for="(dataRow, indexRow) in datax"
							:isSelected="isSelected(dataRow)"
							:key="dataRow['__vKeyValue']"
							:columns="columnx"
							:index="indexRow"
							:dataRow="dataRow"
							:widgetOptions="widgetOptions"
							:widgetOptionsLeft="widgetOptionsLeft"
							:widgetColumn="widgetColumn"
							:serial="serial"
							:pageSize="pageSize"
							:currentPage="currentPage"
							:multiple="multiple"
							:multipleDisabled="multipleDisabled"
							:draggable="draggable"
							:isScrollLeft="isScrollLeft"
							v-on="listeners"
							:class="[
								{ 'row-selected': dataRow == rowSelected.data },
								{ 'action-pointer': checkListenerDbClick },
								typeof customClassRow == 'function'
									? customClassRow(dataRow)
									: customClassRow,
								datax && indexRow == datax.length - 1 ? 'ms-tr-last' : '',
							]"
							:id="`tr-row-${indexRow}`"
							:isTree="isTree"
							:isBorderTr="isBorderTr"
							:isBorderTh="isBorderTh"
							:isActionView="isActionView"
							:isGridReport="isGridReport"
							:rowActions="rowActions"
							:rowActionsWidget="rowActionsWidget"
							:rowActionsWidgetProps="rowActionsWidgetProps"
							:truncateOverflow="truncateOverflow"
							@dataAction="handleAction"
						></ms-tr>
					</draggable>
					<tbody
						v-else-if="shimmerLoaded !== false"
						class="ms-tbody"
						:key="shimmerLoaded"
					>
						<template>
							<ms-tr
								ref="tr"
								v-for="(dataRow, indexRow) in datax"
								:isSelected="isSelected(dataRow)"
								:key="dataRow['__vKeyValue']"
								:columns="columnx"
								:index="indexRow"
								:dataRow="dataRow"
								:widgetOptions="widgetOptions"
								:widgetOptionsLeft="widgetOptionsLeft"
								:widgetColumn="widgetColumn"
								:serial="serial"
								:pageSize="pageSize"
								:currentPage="currentPage"
								:multiple="multiple"
								:multipleDisabled="multipleDisabled"
								:draggable="draggable"
								:isScrollLeft="isScrollLeft"
								v-on="listeners"
								:class="[
									{ 'row-selected': dataRow == rowSelected.data },
									{ 'action-pointer': checkListenerDbClick },
									typeof customClassRow == 'function'
										? customClassRow(dataRow)
										: customClassRow,
									datax && indexRow == datax.length - 1 ? 'ms-tr-last' : '',
								]"
								:id="`tr-row-${indexRow}`"
								:isTree="isTree"
								:isBorderTr="isBorderTr"
								:isBorderTh="isBorderTh"
								:isActionView="isActionView"
								:isGridReport="isGridReport"
								:rowActions="rowActions"
								:rowActionsWidget="rowActionsWidget"
								:rowActionsWidgetProps="rowActionsWidgetProps"
								:truncateOverflow="truncateOverflow"
								@dataAction="handleAction"
							></ms-tr>
						</template>
					</tbody>
					<tbody
						class="ms-tbody"
						v-if="shimmerLoaded === false"
						:key="shimmerLoaded"
					>
						<template>
							<ms-tr
								ref="tr"
								v-for="n in 5"
								:key="n"
								:index="n"
								:columns="columnx"
								:widgetOptions="widgetOptions"
								:widgetOptionsLeft="widgetOptionsLeft"
								:serial="serial"
								:multiple="multiple"
								:draggable="draggable"
								isChart
								:isBorderTr="isBorderTr"
								:isBorderTh="isBorderTh"
								:isActionView="isActionView"
								:isGridReport="isGridReport"
							></ms-tr>
						</template>
					</tbody>
				</transition>
				<slot name="sumrow"></slot>
			</table>
		</div>
		<div v-else class="text-center h-full flex-box justify-center">
			<ms-no-data
				:noDataSlot="noDataSlot"
				:options="getFilterEmptyOptions"
				:isScreenMall="isScreenMall"
			>
				<template #noData>
					<slot name="noData"></slot>
				</template>
			</ms-no-data>
		</div>
		<ms-pagination
			ref="pagination"
			v-if="pagination"
			:pageSize="pageSize"
			:dataRender="datax.length"
			:pageIndexCurrent="currentPage"
			:pageTotal="pageTotal"
			:pageButtomValue="pageButtomValue"
			:pageButtomValueV2="pageButtomValueV2"
			:hasSelectedItemsFromGrid="hasSelectedItems"
			@loadData="listenersLoadData"
			@showPageButtomValueV2="showPageButtomValueV2"
			@viewInfoOptionSelected="onViewOptionSelected"
			:customProp="customProp"
			@clickPage="clickPage"
			:isLoadingTotalRecord="isLoadingTotalRecord"
			:listType="listType"
			:hasPageSize="hasPageSize"
			:isNeedHidAndShowTotal="isNeedHidAndShowTotal"
		>
		</ms-pagination>
	</div>
</template>
<script>
import draggable from 'vuedraggable';
import msTr from './msTr';
import msGroupTr from './msGroupTr';
import msTh from './msTh';
import msPagination from './msPaginationViewer';
import commonFunc from '@/common/commonFunction.js';
import msDynamicScroll from '@/components/msvirtualscroller/MsDynamicScroller.vue';
import msDynamicScrollerItem from '@/components/msvirtualscroller/MsDynamicScrollerItem.vue';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { mapMutations } from 'vuex';
import { isNullOrEmpty, isNullOrUndefined } from '@/common/objectUtil';
export default {
	name: 'msGridViewer',
	components: {
		draggable,
		msTr,
		msGroupTr,
		msTh,
		msPagination,
		msDynamicScroll,
		msDynamicScrollerItem,
	},
	props: {
		isGridReport: {
			default: false,
			type: Boolean,
		},
		greyTitle: {
			default: false,
			type: Boolean,
		},
		hasPageSize: {
			default: true,
			type: Boolean,
		},
		//Value thực hiện lưu giá trị các cột được chọn
		value: {},
		//Data dữ liệu grid từ ngoài truyền vào
		data: {
			type: Array,
			return: () => [],
		},
		//Cấu hình các cột truyền vào
		/**
		 * Các thuộc tính trong columns
		 * @params dataField Field dữ liệu dùng để nhận giá trị thay đổi và hiện thị. Ngăn cách dấu '.' để truy cập sâu vào các đối tượng con
		 * @params title:Tiêu đề của cột
		 * @params width:độ rộng của cột
		 * @params autoResize:Cột tự động to ra khi màn hình lớn
		 * @params formatType:Dữ liệu dùng để format lấy từ trong file enumeration.js FormatType
		 * @params template:Sử dụng 1 file khác ở ngoài truyền vào để render
		 */
		columns: {
			type: Array,
			return: () => [],
		},
		/**
		 * Cấu hình cho cột chức năng là 1 đối tượng gồm có
		 * title: tên tiêu đề cột chức năng
		 * components:'components import vào'
		 * width:Độ rộng của cột
		 */
		widgetOptions: {},
		// Cấu hình cột chức năng thêm bên trái danh sách
		widgetOptionsLeft: {},
		// Cột được thiết lập trong danh sách thiết lập là icon
		widgetColumn: {},
		//Set độ rộng cho grid
		maxHeight: {
			default: null,
			type: [Number, String],
		},
		//Cấu hình có phân trang hay không
		pagination: {
			default: false,
			type: Boolean,
		},
		//Nhận 2 giá trị remote/local để lấy giá trị ở server hoặc local
		queryMode: {
			default: 'remote',
			type: String,
		},
		//Cột cho phép tích chọn nhiều dòng
		multiple: {
			default: false,
			type: Boolean,
		},
		//Có hiên thị kéo thả kéo thả lại dòng không
		draggable: {
			default: false,
			type: Boolean,
		},
		indexFlexRight: {
			default: 1,
			type: Number,
		},
		//Tổng số bản ghi
		pageTotal: {
			default: 0,
			type: Number,
		},
		//Hiện thị cột số thứ tự
		serial: {
			default: false,
			type: Boolean,
		},
		//Cho phép di chuyển độ rộng của cột hay không
		resizeCol: {
			default: true,
			type: Boolean,
		},
		//Trường để kiểm tra sort dưới client hay trên sever
		remoteSort: {
			default: false,
			type: Boolean,
		},
		//Data là dạng Master/Detail
		isMasterDetail: {
			default: false,
			type: Boolean,
		},
		detailField: {
			default: 'Details',
			type: String,
		},
		shimmerLoaded: {
			default: null,
		},
		customClassRow: {
			default: null,
		},
		groupField: {
			default: null,
			type: String,
		},
		loadChildrenData: {
			default: null,
		},
		multipleDisabled: {
			default: false,
			type: Boolean,
		},
		pageButtomValue: {
			type: Array,
			return: () => [],
		},
		pageButtomValueV2: {
			type: Array,
			return: () => [],
		},
		isNeedHidAndShowTotal: {
			default: true,
			type: Boolean,
		},
		//Cho phép sắp xếp cột trên grid hay không
		sortCol: {
			default: false,
			type: Boolean,
		},
		name: {
			default: '',
			type: String,
		},
		isTree: {
			default: false,
			type: Boolean,
		},
		sortCondition: {},
		isCustomAlignDate: {
			default: false,
			type: Boolean,
		},
		nameGrid: {
			default: null,
			type: String,
		},
		/**
		 * Có loading tổng số bản ghi hay không
		 */
		isLoadingTotalRecord: {
			default: false,
			type: Boolean,
		},
		customGridLayout: {},
		isSelectManyPage: {
			default: false,
			type: Boolean,
		},
		/**
		 * Key khóa chính của dữ liệu
		 */
		keyFieldData: {
			default: null,
			type: String,
		},
		/**
		 * Giá trị của lựa chọn tất cả
		 */
		valueAll: {},
		isBorderTr: {
			default: true,
			typeof: Boolean,
		},
		isBorderTh: {
			default: true,
			typeof: Boolean,
		},
		isFirstFilter: {
			default: true,
			typeof: Boolean,
		},
		isActionView: {
			default: false,
			typeof: Boolean,
		},
		/**
		 * có filter cột không
		 */
		filterable: {
			type: Boolean,
			default: false,
		},
		/**
		 * Dữ liệu lọc trên grid
		 */
		filterGrids: {
			type: Array,
			return: () => [],
		},
		listType: 0,
		tooltipCheckboxMulti: {
			type: String,
			default: '',
		},
		noDataSlot: {
			type: Boolean,
			default: false,
		},
		classContentTable: {
			default: '',
			typeof: String,
		},
		classContentHeader: {
			default: '',
			typeof: String,
		},
		customProp: {},
		gridViewClass: {
			default: '',
			typeof: String,
		},
		/**
		 * Bật truncate text trong cell: text dài quá width cột thì ẩn bớt (ellipsis),
		 * hover xem đầy đủ qua tooltip. Mặc định false giữ behavior cũ (giãn cột theo nội dung).
		 */
		truncateOverflow: {
			default: true,
			type: Boolean,
		},
		isCheckboxHasAfter: {
			default: false,
			typeof: Boolean,
		},
		filterEmptyOptions: {},
		/**
		 * Cấu hình các tuỳ chọn chung của grid
		 * @params hideLastRowBorderOnScroll Bỏ border-bottom của dòng cuối khi grid có scroll dọc, tránh đè lên border khung bao ngoài (vd class grid-has-border)
		 */
		gridOptions: {},
	},
	/**
	 * Hàm khởi tạo grid khởi tạo column vào data
	 * Created by LTDAT 16.06.2020
	 */
	created() {
		const me = this;
		me.initColumns();
		me.initData();
		me.initFilterGrids();
		document.addEventListener('click', me.clickOutGrid);
		window.addEventListener('resize', me.onResize);
	},
	/**
	 *
	 */
	watch: {
		data: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.checkHasScroll();
				if (me.datax != me.data) {
					me.initData(newVal);
					if (!me.remoteSort && me.sortCondition && me.sortCondition.col) {
						me.sort(me.sortCondition.col, me.sortCondition.sortStatus);
					}
				}
			},
		},

		filterGrids: {
			handler(newVal, oldVal) {
				const me = this;
				if (!_.isEqual(me.filterHeaders, me.filterGrids)) {
					me.initFilterGrids(newVal);
				}
			},
		},

		pageTotal: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.currentPage = 1;
			},
		},

		columns: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.initColumns();
			},
		},
		value: {
			immediate: true,
			handler(newVal) {
				const me = this;
				if (
					me.$refs.pagination &&
					me.$refs.pagination.selectedViewOption ===
						me.$ms.enum.ViewInfoType.ViewSelected
				) {
					if (!newVal || newVal.length <= 0) {
						me.$refs.pagination.selectedViewOption = null;
						me.$refs.pagination.isHideValue = true;
					}
					me.$emit(
						'viewInfoOptionSelected',
						me.$ms.enum.ViewInfoType.ViewSelected
					);
				}
			},
		},
		isScreenMall: {
			handler(newVal, oldVal) {
				const me = this;
				me.isScreenMall = me.$ms.commonFunc.checkSmallScreen();
			},
		},
	},
	mounted() {},
	computed: {
		//Kiểm tra có lắng nghe xử lý sự kiện dblick hay không? nếu có thì đổi icon thành pointer
		checkListenerDbClick() {
			if (this._events.dblclick && this._events.dblclick.length > 0) {
				return true;
			}
			return false;
		},
		//Hàm kiểm tra xem có scroll hay không?
		scrollVisiable() {
			if (this.hasScroll) {
				return true;
			}
			return false;
		},
		/**
		 * Chỉ bỏ border-bottom dòng cuối khi grid đang có scroll dọc VÀ cha cho phép qua props gridOptions
		 */
		isHideLastRowBorderOnScroll() {
			const me = this;
			return !!(
				me.hasScroll &&
				me.gridOptions &&
				me.gridOptions.hideLastRowBorderOnScroll
			);
		},
		/**
		 * Danh sách action hiển thị nổi lên (overlay icon) ở cột cuối cùng khi hover vào dòng
		 * Truyền qua gridOptions.rowActions để tái sử dụng ở nhiều danh sách, không cần thêm cột widget riêng ở từng nơi dùng grid
		 */
		rowActions() {
			const me = this;
			return (me.gridOptions && me.gridOptions.rowActions) || null;
		},
		/**
		 * Component widget tùy chỉnh render vào overlay ở cột cuối cùng khi hover, thay cho rowActions.
		 * Truyền qua gridOptions.rowActionsWidget khi danh sách muốn tự xử lý action trong 1 component riêng
		 */
		rowActionsWidget() {
			const me = this;
			return (me.gridOptions && me.gridOptions.rowActionsWidget) || null;
		},
		/**
		 * Props tùy biến forward xuống rowActionsWidget qua msTr, đọc từ gridOptions.rowActionsWidgetProps.
		 * Mặc định {} — không ảnh hưởng danh sách nào chưa truyền option này.
		 */
		rowActionsWidgetProps() {
			const me = this;
			return (me.gridOptions && me.gridOptions.rowActionsWidgetProps) || {};
		},
		//Sự kiện từ 1 dòng dữ liệu emit ra ngoài
		//Created by LTDAT(18.06.2020)
		listeners() {
			const me = this;
			return {
				click: (dataRow, event) => {
					event.target.focus();
					me.$emit('click', dataRow, event);
				},
				focus: (dataRow, event) => {
					if (me.rowSelected && me.rowSelected.data != dataRow) {
						let indexRow = me.datax.findIndex((item) => item == dataRow);
						me.rowSelected = {
							data: dataRow,
							index: indexRow,
						};
						event.target.focus();
					}
				},
				dblclick: (dataRow, event) => {
					me.$emit('dblclick', dataRow, event);
				},
				keydown: (dataRow, event) => {
					me.row_keydown(dataRow, event);
					me.$emit('keydown', dataRow, event);
				},
				widgetEvent: (data, event) => {
					me.$emit('widgetEvent', data, event);
				},
				clickMultiple: (dataRow) => {
					me.clickMultiple(dataRow);
				},
				rowAction: (data) => {
					me.$emit('rowAction', data);
				},
			};
		},
		/**
		 * Danh sách dòng được tính vào cơ chế "chọn tất cả" / "bỏ chọn tất cả"
		 * Cho phép grid cha loại trừ 1 số dòng đặc thù (VD: user hiện tại) khỏi vùng đếm
		 * bằng cách truyền gridOptions.isRowSelectable(dataRow) => Boolean
		 * Mặc định (không truyền) thì trả nguyên datax, không đổi hành vi các nơi khác
		 */
		selectableDatax() {
			const me = this;
			if (!me.datax) return [];
			if (
				me.gridOptions &&
				typeof me.gridOptions.isRowSelectable === 'function'
			) {
				return me.datax.filter((item) => me.gridOptions.isRowSelectable(item));
			}
			return me.datax;
		},
		/**
		 * Kiểm tra xem tất cả dữ liệu có đang được check hay không
		 * created by LTDAT 25.06.2020
		 */
		isCheckedMultiple() {
			const me = this;
			if (
				!me.value ||
				!me.selectableDatax ||
				me.selectableDatax.length <= 0 ||
				me.value.length < me.selectableDatax.length
			)
				return false;
			return me.selectableDatax.every((item) => {
				if (me.keyFieldData) {
					let exist = me.value.find(
						(x) => x[`${me.keyFieldData}`] == item[`${me.keyFieldData}`]
					);
					if (exist) return true;
				}
				return me.value.includes(item);
			});
		},

		isCheckedSomeData() {
			const me = this;
			if (!me.selectableDatax || me.isCheckedMultiple) return false;
			const lstDataSelected = me.selectableDatax.filter((item) =>
				me.isSelected(item)
			);
			return (
				lstDataSelected &&
				lstDataSelected.length > 0 &&
				lstDataSelected.length < me.selectableDatax.length
			);
		},
		// //Set style cho grid độ rộng,...
		gridViewStyle() {
			if (this.maxHeight) {
				return { 'max-height': this.maxHeight };
			} else {
				return null;
			}
		},
		dataEmpty() {
			if (this.datax && this.datax.length > 0) {
				return false;
			} else return true;
		},
		hasSelectedItems() {
			return (
				this.customProp &&
				this.customProp.hasComboboxPaging &&
				this.value &&
				this.value.length > 0
			);
		},
		getFilterEmptyOptions() {
			const me = this;
			if (!me.filterEmptyOptions) return {};
			return me.filterEmptyOptions;
		},
	},
	//Nếu dữ liệu thay đổi thì check scroll
	updated() {
		const me = this;
		me.updateSize();
	},
	methods: {
		...mapMutations(['updateLoadingTotalAmountPage']),

		onViewOptionSelected(metaData) {
			this.$emit('viewInfoOptionSelected', metaData);
		},
		showPageButtomValueV2(isShow) {
			const me = this;
			if (!isShow) return;
			me.$emit('showPageButtomValueV2');
		},
		/**
		 * Khi màn hình thay đổi thì update lại các cột.
		 * Created by LTDAT(19/01/2020)
		 */
		onResize() {
			const me = this;
			me.initColumns();
			me.updateSize();
		},
		/**
		 * Hàm Cập nhật lại giao diện khi có scroll hay khi độ rộng của data dài hơn độ rộng mặc định của cột
		 * Created by LTDAT
		 */
		updateSize() {
			const me = this;
			me.$nextTick(() => {
				me.checkHasScroll();
				// Khi bật truncateOverflow thì cố định width cột theo cấu hình, không tự giãn theo nội dung
				if (me.truncateOverflow) return;
				if (me.$refs.tr && me.$refs.tr.length > 0) {
					me.columnx.forEach((col, index) => {
						let changeMinWidth = false;
						// Duyệt các dòng
						me.$refs.tr.forEach((item) => {
							if (
								item.$refs[`text-${col.dataField}`] &&
								item.$refs[`text-${col.dataField}`].length > 0
							) {
								let textSpan =
									item.$refs[`text-${col.dataField}`][0].offsetWidth;
								if (col._width < textSpan + 20) {
									changeMinWidth = true;
									if (
										me.$refs.th[index].$el.offsetWidth !=
										item.$refs[`td-${col.dataField}`][0].offsetWidth
									) {
										me.$set(
											col,
											'_minWidth',
											item.$refs[`td-${col.dataField}`][0].offsetWidth
										);
										me.$set(
											col,
											'_width',
											item.$refs[`td-${col.dataField}`][0].offsetWidth
										);
									}
								}
							}
						});
						if (changeMinWidth == false) {
							me.$set(col, '_minWidth', col._width);
						}
					});
				}
			});
		},
		/**
		 * Hàm trước thực hiện transition bắt đầu render.
		 * Created by LTDAT
		 */
		beforeRenderContent() {
			const me = this;
			me.updateSize();
		},
		/**
		 * Thực hiện khi ấn vào ngoài grid loại bỏ row đang chọn
		 * Created by LTDAT
		 *
		 * */
		clickOutGrid(event) {
			const me = this;
			if (event.target.closest('.ms-grid-viewer') != me.$el) {
				me.rowSelected = {};
			}
		},
		/**
		 * Hàm thực hiện việc sort trên grid
		 * @params col cột được thực hiện sắp sếp
		 * @params mode gồm null,DESC,ASC
		 * created by LTDAT
		 */
		sort(col, mode) {
			const me = this;
			// Cột không được sort dữ liệu
			if (!col || !col.isSort) return;

			if (me.datax && me.datax.length > 0) {
				//Cập nhật thông tin sort vào biến
				me.updateRemoteSortMode(mode);
				//Sort dữ liệu danh sách từ server
				if (me.remoteSort) {
					let payload = {
						skip: 0, //mặc định khi bấm sort thì quay về trang 1 với mode sort server
						take: me.pageSize,
					};

					// Sử dụng trực tiếp tham số col được truyền vào thay vì dùng getParamSort()
					// Fix: Khi click sort cột mới, đảm bảo sort đúng cột được click chứ không phải cột cũ
					if (col && mode != me.$ms.enum.SortStatus.none) {
						payload.SortParams = [
							{
								FieldName: col.dataField,
								Descending: mode == me.$ms.enum.SortStatus.desc ? true : false,
							},
						];
					}

					//Thưc hiện call event load dữ liệu
					me.listenersLoadData(payload);
				} else {
					let data = [...me.internalDataSource];

					if (mode != me.$ms.enum.SortStatus.none) {
						if (col && col.formatType === me.$ms.enum.FormatType.Number) {
							// Sử dụng hàm compare cho Number
							me.datax = data.sort((a, b) => me.compareNumber(a, b, col, mode));
						} else {
							// Sử dụng hàm compare cho các kiểu khác
							me.datax = data.sort((a, b) => me.compareOther(a, b, col, mode));
						}
					} else {
						me.datax = data;
					}

					me.$emit('loadDataSort', me.datax);
				}
			}
		},

		/**
		 * Hàm so sánh cho kiểu Number
		 * @param {Object} a - object đầu tiên để so sánh
		 * @param {Object} b - object thứ hai để so sánh
		 * @param {Object} col - cột đang sort
		 * @param {Number} mode - chế độ sort (ASC/DESC)
		 */
		compareNumber(a, b, col, mode) {
			const me = this;
			const valueA = a[col.dataField];
			const valueB = b[col.dataField];

			// Kiểm tra giá trị null/undefined (không bao gồm 0)
			const isNullA = isNullOrUndefined(valueA);
			const isNullB = isNullOrUndefined(valueB);

			// Xử lý null/undefined - luôn đặt cuối cùng
			if (isNullA && !isNullB) {
				return 1; // A null, B có giá trị -> A xuống cuối
			}
			if (!isNullA && isNullB) {
				return -1; // A có giá trị, B null -> B xuống cuối
			}
			if (isNullA && isNullB) {
				return 0; // Cả hai đều null -> bằng nhau
			}

			// So sánh giá trị số thực tế (bao gồm 0)
			if (mode == me.$ms.enum.SortStatus.desc) {
				// Sort giảm dần: số dương → 0 → số âm
				if (valueA > valueB) return -1;
				if (valueA < valueB) return 1;
			} else {
				// Sort tăng dần: số âm → 0 → số dương
				if (valueA < valueB) return -1;
				if (valueA > valueB) return 1;
			}

			// Nếu bằng nhau, sort theo CreatedDate
			if (valueA == valueB) {
				if (a['CreatedDate'] > b['CreatedDate']) {
					return mode == me.$ms.enum.SortStatus.asc ? 1 : -1;
				}
				if (a['CreatedDate'] < b['CreatedDate']) {
					return mode == me.$ms.enum.SortStatus.desc ? 1 : -1;
				}
			}
			return 0;
		},

		/**
		 * Hàm so sánh cho các kiểu khác (text, date, etc.)
		 * @param {Object} a - object đầu tiên để so sánh
		 * @param {Object} b - object thứ hai để so sánh
		 * @param {Object} col - cột đang sort
		 * @param {Number} mode - chế độ sort (ASC/DESC)
		 */
		compareOther(a, b, col, mode) {
			const me = this;
			if (!a[col.dataField] && b[col.dataField]) {
				return mode == me.$ms.enum.SortStatus.desc ? 1 : -1;
			}
			if (a[col.dataField] && !b[col.dataField]) {
				return mode == me.$ms.enum.SortStatus.asc ? 1 : -1;
			}
			if (a[col.dataField] < b[col.dataField])
				return mode == me.$ms.enum.SortStatus.desc ? 1 : -1;
			if (a[col.dataField] > b[col.dataField])
				return mode == me.$ms.enum.SortStatus.asc ? 1 : -1;
			if (a[col.dataField] == b[col.dataField]) {
				if (a['CreatedDate'] > b['CreatedDate']) {
					return mode == me.$ms.enum.SortStatus.asc ? 1 : -1;
				}
				if (a['CreatedDate'] < b['CreatedDate']) {
					return mode == me.$ms.enum.SortStatus.desc ? 1 : -1;
				}
			}
			return 0;
		},

		//Kiểm tra xem grid có scroll hay không để chỉnh lại size của grid cho đúng
		//Created by LTDAT (29.07.2020)
		checkHasScroll() {
			this.$nextTick(() => {
				if (this.$refs.content) {
					if (
						this.$refs.content.getBoundingClientRect().height + 2 <
						this.$refs.content.scrollHeight
					) {
						this.hasScroll = true;
					} else {
						this.hasScroll = false;
					}
				}
			});
		},
		/**
		 * Hàm lắng nghe sự kiến thay đổi trang nếu thay đổi thì emit sự kiện load data mới ra ngoài
		 * @param payload dữ liệu thông tin trang gửi ra ngoài
		 *  */
		//Created by LTDAT(27.07.2020)
		listenersLoadData(payload, loadFirstIndex = false) {
			const me = this;
			if (me.pagination) {
				me.currentPage = payload.skip / payload.take + 1;
				me.pageSize = payload.take;
			}

			// Fix: Khi phân trang/chuyển trang, cần lấy lại thông tin sort hiện tại
			// để đảm bảo dữ liệu luôn được sort đúng theo cột đang được chọn
			if (!payload.SortParams) {
				let sortInfo = me.getParamSort();
				if (
					sortInfo &&
					sortInfo.col &&
					sortInfo.sortStatus != me.$ms.enum.SortStatus.none
				) {
					payload.SortParams = [
						{
							FieldName: sortInfo.col.dataField,
							Descending: sortInfo.sortStatus == me.$ms.enum.SortStatus.desc,
						},
					];
				}
			}

			if (loadFirstIndex && me.currentPage != 1) {
				me.currentPage = 1;
			}
			me.$emit('loadData', payload);
		},

		hidePageButtomValueV2() {
			const me = this;
			let pagination = me.$refs.pagination;
			if (
				pagination &&
				me.pageButtomValueV2 &&
				me.pageButtomValueV2.length > 0
			) {
				// Nếu ở option chọn combobox là Chỉ xem hóa đơn được chọn thì emit sự kiện để tính toán lại
				if (
					pagination.selectedViewOption ===
					me.$ms.enum.ViewInfoType.ViewSelected
				) {
					me.$emit(
						'viewInfoOptionSelected',
						me.$ms.enum.ViewInfoType.ViewSelected
					);
					return;
				}

				if (!pagination.isHideValue) {
					pagination.isHideValue = true;
				}
				me.updateLoadingTotalAmountPage(false);
			}
		},

		/**
		 * Lấy thông tin tham số trường và trạng thái sort
		 * Fix: Lấy từ sortCondition (single source of truth) thay vì duyệt $refs.th
		 * để tránh lỗi sort sai cột khi chuyển trang
		 */
		getParamSort() {
			const me = this;

			// ✅ Lấy trực tiếp từ sortCondition - nguồn dữ liệu đáng tin cậy
			// Tránh lỗi: khi sort cột mới, cột cũ trong $refs.th chưa được reset
			if (
				me.sortCondition &&
				me.sortCondition.col &&
				me.sortCondition.sortStatus != me.$ms.enum.SortStatus.none
			) {
				return {
					col: me.sortCondition.col,
					sortStatus: me.sortCondition.sortStatus,
				};
			}

			return null;
		},
		//Hàm sự kiện khi ấn nút chọn tất cả trên tiêu đề
		//Created by LTDAT
		changeCheckedMultiple() {
			const me = this;
			me.setDataSelectInGrid();
		},

		setDataSelectInGrid() {
			const me = this;
			//Lựa chọn select dữ liệu trên nhiều page
			if (me.isSelectManyPage) {
				if (me.isCheckedMultiple) {
					me.setDataSelectPage(me.selectableDatax, true);
					me.$emit('input', me.dataAll);
				} else {
					me.setDataSelectPage(me.selectableDatax, false);
					me.$emit('input', me.dataAll);
				}
			} else {
				if (me.isCheckedMultiple) {
					me.$emit('input', []);
				} else {
					me.$emit('input', me.selectableDatax);
				}
			}
		},

		setDataSelectPage(datax, isDelete = false) {
			const me = this;
			if (!datax || datax.length <= 0) return;
			if (!me.dataAll || me.dataAll.length <= 0) me.dataAll = [];
			if (isDelete) {
				if (me.keyFieldData) {
					me.dataAll = me.dataAll.filter(
						(x) =>
							!datax.find(
								(a) => a[`${me.keyFieldData}`] == x[`${me.keyFieldData}`]
							)
					);
				} else {
					me.dataAll = me.dataAll.filter((x) => !datax.includes(x));
				}
			} else {
				me.dataAll = [...me.dataAll, ...datax];
				//Distinct  data array
				if (me.keyFieldData) {
					me.dataAll = me.$ms.commonFunc.distinctArray(
						me.dataAll,
						me.keyFieldData
					);
				}
			}
		},

		/**
		 * Sự kiện scroll trên grid
		 * Thay đổi lại tọa độ scroll trên header
		 * Created by LTDAT(25.06.2020)
		 */
		onScroll(e) {
			const me = this;
			if (me.$refs.header) {
				me.$refs.header.scrollLeft = e.target.scrollLeft;
			}
			if (e.target.scrollLeft != 0) {
				me.isScrollLeft = true;
			} else {
				me.isScrollLeft = false;
			}
			let gridCoordinates = me.$refs.content.scrollLeft;
			EventBusGlobal.$emit(GlobalEventName.scrollEvent, e);
			me.$emit('scroll', e, gridCoordinates);
		},

		/**
		 * Hàm scroll tới vị trí chỉ định
		 * @param {*} gridCoordinates
		 * @author hvanh - 19.1.2024
		 */
		onScrollToCoordinates(gridCoordinates) {
			const me = this;
			if (!me.$refs.content || (!gridCoordinates && gridCoordinates !== 0))
				return;

			if (typeof gridCoordinates == 'number' && gridCoordinates >= 0) {
				me.$refs.content.scrollLeft = gridCoordinates;
			}
		},

		/**
		 * Hàm scroll content và header tới vị trí chỉ định
		 */
		onScrollLeftGridToCoordinates(gridCoordinates) {
			const me = this;
			if (
				!me.$refs.content ||
				!me.$refs.header ||
				(!gridCoordinates && gridCoordinates !== 0) ||
				(typeof gridCoordinates != 'number' && gridCoordinates < 0)
			) {
				return;
			}

			// Gọi scoll content tới vị trí chỉ định
			me.$refs.content.scrollLeft = gridCoordinates;
			// Gọi scroll header tới vị trí chỉ định
			me.$refs.header.scrollLeft = gridCoordinates;
		},

		/**
		 * Kiểm tra xem cột được check hay không ?
		 * duyệt trong data nếu có chưa dữ liệu của dòng tương ứng thì return true ngược lại false
		 * @param dataRow dữ liệu của dòng được check
		 * Created by LTDAT 24.06.2020
		 *  */
		isSelected(dataRow) {
			const me = this;
			if (me.value && me.value.length > 0) {
				if (me.keyFieldData) {
					let exist = me.value.find(
						(x) => x[`${me.keyFieldData}`] == dataRow[`${me.keyFieldData}`]
					);
					if (exist) return true;
				}
				return me.value.includes(dataRow);
			}
			return false;
		},
		/**
		 * Hàm xử lý sự kiện khi click vào ô check multiple
		 * @param dataRow dữ liệu của dòng được chọn
		 * Created by LTDAT (30.05.2020)
		 */
		clickMultiple(dataRow) {
			const me = this;
			let VModel = [...me.value];

			if (me.keyFieldData) {
				if (me.isSelectManyPage) {
					// Multi-page: dùng dataAll để track selection xuyên trang
					if (me.dataAll.length === 0 && me.value && me.value.length > 0) {
						me.dataAll = [...me.value];
					}
					let checkExist = me.dataAll.find(
						(x) => x[`${me.keyFieldData}`] == dataRow[`${me.keyFieldData}`]
					);
					if (checkExist) {
						me.dataAll = me.dataAll.filter(
							(x) => x[`${me.keyFieldData}`] != dataRow[`${me.keyFieldData}`]
						);
					} else {
						me.dataAll.push(dataRow);
					}
					VModel = me.dataAll;
				} else {
					// Single page: dùng VModel trực tiếp, tránh dataAll rỗng gây mất selection
					const existIndex = VModel.findIndex(
						(x) => x[`${me.keyFieldData}`] == dataRow[`${me.keyFieldData}`]
					);
					if (existIndex >= 0) {
						VModel.splice(existIndex, 1);
					} else {
						VModel.push(dataRow);
					}
				}
			} else {
				if (VModel.includes(dataRow)) {
					VModel.remove(dataRow);
				} else {
					VModel.push(dataRow);
				}
			}
			// Lấy danh sách được chọn: sắp xếp giống như trên phần mềm
			if (me.datax) {
				for (let i = 0; i < VModel.length - 1; i++) {
					for (let j = i + 1; j < VModel.length; j++) {
						let index = me.datax.findIndex(
							(data) =>
								data[`${me.keyFieldData}`] == VModel[i][`${me.keyFieldData}`]
						);
						let index1 = me.datax.findIndex(
							(data) =>
								data[`${me.keyFieldData}`] == VModel[j][`${me.keyFieldData}`]
						);
						let tem = {};
						if (index > index1) {
							tem = VModel[i];
							VModel[i] = VModel[j];
							VModel[j] = tem;
						}
					}
				}
			}
			me.$emit('input', VModel);
			me.$emit('clickMultipleRow', dataRow);
		},

		//Lấy dữ liệu của 1 trang khi phân trang local
		//Created by LTDAT(18.06.2020)
		getItemPagination() {
			let me = this,
				pageSize = me.pageSize
					? me.pageSize
					: me.$ms.commonFunc.getTakePageSize(),
				min = Math.ceil((me.currentPage - 1) * pageSize),
				max = min + pageSize;
			let dataPagination = me.internalDataSource.filter((item, index) => {
				return index >= min && index < max;
			});
			return dataPagination;
		},

		/**
		 * Bắt đầu resize cột
		 */
		onResizeStart(event, col) {
			const me = this;
			me.colCurrentResize = col;
			let columnIndex = me.columnx.findIndex((c) => c == col);
			if (columnIndex == -1) return;
			me.resizingColumn = columnIndex;
			me.startX = event.clientX;
			me.startWidth = me.columnx[columnIndex].width;

			// Lắng nghe sự kiện chuột
			document.addEventListener('mousemove', me.onResizing);
			document.addEventListener('mouseup', me.onResizeEnd);
		},

		/**
		 * Thực hiện resize cột trên grid
		 */
		onResizing(event) {
			const me = this;
			if (me.resizingColumn !== null) {
				const deltaX = event.clientX - me.startX;
				const minWidthResize =
					me.colCurrentResize && me.colCurrentResize.minWidthResize
						? me.colCurrentResize.minWidthResize
						: 80;
				const newWidth = Math.max(minWidthResize, me.startWidth + deltaX);
				me.$set(me.columnx, me.resizingColumn, {
					...me.columnx[me.resizingColumn],
					width: newWidth,
					_minWidth: newWidth,
					_width: newWidth,
				});
			}
		},

		/**
		 * Kết thúc resize cột trên grid
		 */
		onResizeEnd() {
			const me = this;
			me.resizingColumn = null;
			me.colCurrentResize = null;
			document.removeEventListener('mousemove', me.onResizing);
			document.removeEventListener('mouseup', me.onResizeEnd);

			// Cập nhật lại minHeight của header sau khi resize
			me.updateHeaderMinHeight();

			// Clone columns trước khi emit để đảm bảo không mutate
			const columnsToEmit = JSON.parse(JSON.stringify(me.columnx));
			me.$emit('apply', columnsToEmit);
		},

		/**
		 * Cập nhật minHeight của header dựa trên chiều cao thực tế của nội dung
		 * Đảm bảo header luôn fit với nội dung, tránh khoảng trống khi resize cột
		 * Created by: hvanh - 13.11.2025
		 */
		updateHeaderMinHeight() {
			const me = this;
			me.$nextTick(() => {
				let header = me.$refs.header;
				if (header && header.firstElementChild) {
					let childHeight = header.firstElementChild.offsetHeight;
					// Bỏ qua khi header chưa visible (popup inactive): offsetHeight = 0 → set min-height 1px sai → border ms-th bị clip
					if (childHeight > 0) {
						header.style.minHeight = childHeight + 1 + 'px';
					}
				}
			});
		},

		//Đóng sự kiện resize cột trên grid
		//created by LTDAT(29.05.2020)

		resizeClose() {
			//Cho phép bôi đên text
			this.isResizeActive = false;
		},
		/**
		 * Set giá trị default cho cấu hình cột
		 * Created by LTDAT(17.07.2020)
		 */
		setDefaultFieldColumn(columns) {
			//Nếu không cấu hình field hiện thị thì mặc định là true
			const me = this;
			columns.forEach((item) => {
				if (item.visiable != false) {
					item.visiable = true;
				}
				if (item.formatType == me.$ms.enum.FormatType.Number && !item.align) {
					item.align = 'right';
				} else if (
					item.formatType == me.$ms.enum.FormatType.Date ||
					item.formatType == me.$ms.enum.FormatType.DateTime
				) {
					if (me.isCustomAlignDate) {
						item.align = 'left';
					} else {
						item.align = 'center';
					}
				}
				me.$set(item, '_width', item.width);
				//default filter
				if (!item.filter) {
					me.setDefaultFilter(item);
				}
			});
		},
		/** Lấy ra các column có thuộc tính visiable = true
		 * Created by LTDAT 17.07.2020
		 * */
		getVisiableColumn(columns) {
			return columns.filter((item) => {
				return item.visiable == true;
			});
		},
		/**
		 * Khởi tạo dữ liệu ban đầu cho grid
		 * columns truyền vào mặc định là columns trong props có thể truyền cấu hình khác từ ngoài vào
		 */
		initColumns(columns = this.columns) {
			const me = this;
			me.columnx = [];
			me.$nextTick(() => {
				me.columnx = columns ? columns : me.columns;
				me.setDefaultFieldColumn(me.columnx);
				me.columnx = me.getVisiableColumn(me.columnx);
				if (!me.columnx) {
					me.columnx = [];
				}
				let hasFlex = me.columnx.some((item) => {
					return item.autoResize;
				});
				if (
					hasFlex == false &&
					me.columnx[me.columnx.length - me.indexFlexRight]
				) {
					// me.resizeActive();
					me.$set(
						me.columnx[me.columnx.length - me.indexFlexRight],
						'autoResize',
						true
					);
				} else if (hasFlex == false && me.columnx.length == 1) {
					me.$set(me.columnx[0], 'autoResize', true);
				}
				// Cập nhật minHeight của header
				me.updateHeaderMinHeight();
			});
		},
		//Xóa 1 phần tử trong data grid
		removeItem(item) {
			const me = this;
			me.datax = _.remove(me.datax, (e) => {
				return e !== item;
			});
		},

		/**
		 * Gán giá trị để render data có thể truyền từ ngoài vào
		 */
		initData(data = this.data) {
			const me = this;
			me.internalDataSource = null;
			if (data) {
				me.internalDataSource = [...data];
			}
			//Nếu thực hiện lấy data dưới local thì thức hiện lưu dữ liệu vào internalDataSource và phân trang local
			if (me.queryMode == 'local' && me.pagination) {
				commonFunc.genVKeyValue(me.internalDataSource);
				me.datax = me.getItemPagination();
			} else {
				//Lấy dữ liệu từ server
				//Tạm gán = props data sau gán = gì khác tính sau
				me.datax = [...me.internalDataSource];
				commonFunc.genVKeyValue(me.datax);
			}
			if (me.isMasterDetail) {
				me.datax = me.$ms.commonFunc.getBodyData(
					me.datax,
					true,
					1,
					me.detailField
				);
			}
			me.$nextTick(() => {
				this.checkHasScroll();
			});
		},

		/**
		 * Gán giá trị filter truyền từ ngoài vào grid để hiển thị lọc theo các column
		 */
		initFilterGrids(filterGrids = this.filterGrids) {
			const me = this;
			if (!filterGrids || filterGrids.length <= 0) {
				return;
			}

			for (let i = 0; i < filterGrids.length; i++) {
				let item = filterGrids[i];
				// Gán giá trị cho filter header nếu đã tồn tại
				let check = me.filterHeaders.find((x) => x.FieldName == item.FieldName);
				if (check) {
					check.Value = item.Value;
					check.ValueText = item.ValueText;
				} else {
					me.filterHeaders.add(item);
				}

				//Thêm cờ check k cho show action lên header
				if (item.IsNotShowActionFilter) continue;

				// Gán cờ hiển thị button lọc cột
				// Kiểm tra đã render xong code thì mới xử lý tìm th
				if (me.$refs && me.$refs.th) {
					let th = me.$refs.th.find((x) => x.col.dataField == item.FieldName);
					if (th != null) {
						th.showOption = true;
						th.col.hasActionFilter = true;
					}
				}
			}
		},

		//Lấy dữ liệu của dòng được chọn
		//Created by LTDAT(16.06.2020)
		getRowSelected() {
			const me = this;
			return me.rowSelected;
		},
		//Xử lý sự kiện ấn phím trên row
		//Created by LTDAT(15.06.2020)
		row_keydown(dataRow, e) {
			const me = this;
			let currentIndex = me.rowSelected.index;
			switch (e.which) {
				case 40: //down
					if (currentIndex < me.datax.length - 1 && !e.altKey) {
						currentIndex++;
						event.target.focus();
						me.rowSelected.data = me.datax[currentIndex];
						me.rowSelected.index = currentIndex;
						e.preventDefault();
					}
					break;
				case 38: //up
					if (currentIndex > 0 && !e.altKey) {
						currentIndex--;
						event.target.focus();
						me.rowSelected.data = me.datax[currentIndex];
						me.rowSelected.index = currentIndex;
						e.preventDefault();
					}
					break;
			}
		},
		clickPage() {
			const me = this;
			if (me.$refs.th && me.sortCol) {
				for (let i = 0; i < me.$refs.th.length; i++) {
					if (me.$refs.th[i].sortStatus != me.$ms.enum.SortStatus.none) {
						me.sort(me.columnx[i], me.$refs.th[i].sortStatus);
						return;
					}
				}
			}
		},

		resetDataAllSelected() {
			const me = this;
			me.dataAll = [];
		},
		/**
		 * Cập nhật dữ liệu chọn trên ds
		 */
		setDataAllSelected(lstData) {
			const me = this;
			me.dataAll = lstData;
			me.$emit('input', me.dataAll);
		},
		onClickiconAfterTitle() {
			const me = this;
			me.$emit('onClickiconAfterTitle');
		},

		/**
		 * Gán filter mặc định cho column
		 */
		setDefaultFilter(column) {
			const me = this;
			column.filter = {
				value: null,
				operator: me.setOperatorDefault(column.formatType),
			};

			switch (column.columnType) {
				case 'ColumnText':
				case 'ColumnDrilldown':
					if (!column.enumName || column.enum) {
						column.filter.operator = me.$ms.enum.FilterOperator.Contains;
					}
					break;
			}
		},

		/**
		 * hàm xóa 1 item filter lọc
		 * isUnfilter: Cờ đánh dấu đi từ chức năng bỏ lọc trên cột thì sẽ không emit nữa
		 */
		removeFilterItem(item, isUnfilter = false) {
			let me = this;
			//Nếu item truyền vào là loại col thì sẽ có dataField
			let isCol = item.dataField;
			if (isCol) {
				me.filterHeaders.remove(
					me.filterHeaders.find((x) => x.FieldName === item.dataField)
				);
			} else {
				me.filterHeaders.remove(
					me.filterHeaders.find((x) => x.FieldName === item.FieldName)
				);
			}
			let th = me.$refs.th.filter(
				(x) => x.col.dataField == (isCol ? item.dataField : item.FieldName)
			);
			if (th && th.length > 0) {
				th[0].col.filter.value = null;
				th[0].col.filter.operator = me.setOperatorDefault(th[0].col.formatType);
				th[0].col.hasActionFilter = false;
				th[0].checkHideButtonHeaderFilter();
			}
			if (!isUnfilter) me.$emit('loadFilterHeader', item);
		},

		/**
		 * hàm conver toán tử thành text: ví dụ "Contants" -> "Chứa"
		 */
		buildOperatorText(operator) {
			let operatorText = this.$ms.commonFunc.getDataFromEnumExactly(
				'FilterOperator',
				operator
			);
			if (operatorText) {
				operatorText = operatorText[0].display;
			}
			return operatorText;
		},

		/**
		 * hàm build value filter
		 */
		buildValue(item) {
			let me = this;
			if (
				item.Operator == me.$ms.enum.FilterOperator.IsNull ||
				item.Operator == me.$ms.enum.FilterOperator.IsNotNull
			) {
				return '';
			}

			return `${item.ValueText}`;
		},

		/**
		 * Build ra title
		 */
		buildTitleText(item) {
			let me = this;
			let text = me.$t(
				`${me.customGridLayout.i18n}.${me.customGridLayout.layoutID}`
			)[`${item.FieldName}`];
			if (isNullOrEmpty(text)) return item.Title;
			else return text;
		},

		/**
		 * lưu tất cả các cột đã đánh dấu là đang filter
		 */
		buildFilterHeader(col) {
			let me = this;
			let valueText = '';
			let isFilterAll = false; //Cờ đánh dấu lọc enum là tất cả thì sẽ xóa bộ lọc đi
			switch (col.formatType) {
				case me.$ms.enum.FormatType.Enum:
					//Kiểm tra giá trị làm array không?
					let isArray = Array.isArray(col.filter.value);
					if (isArray) {
						valueText = col.filter.value
							.map((x) =>
								me.$options.filters.formatData(x.value, {
									formatType: col.formatType,
									enumName: col.enumName,
								})
							)
							.join(', ');
						if (
							col.filter.value.length == 1 &&
							col.filter.value[0].value == me.$ms.enum[col.enumName].All
						) {
							isFilterAll = true;
						}
					} else {
						valueText = me.$options.filters.formatData(col.filter.value, {
							formatType: col.formatType,
							enumName: col.enumName,
						});
					}
					break;
				case me.$ms.enum.FormatType.EnumOne:
					valueText = me.$options.filters.formatData(col.filter.value, {
						formatType: col.formatType,
						enumName: col.enumName,
					});
					if (col.filter.value == me.$ms.enum[col.enumName].All) {
						isFilterAll = true;
					}
					break;
				case me.$ms.enum.FormatType.Date:
					if (col.filter.operator == me.$ms.enum.FilterOperator.Between) {
						valueText = `${me.$options.filters.formatData(col.filter.from, {
							formatType: col.formatType,
						})} - ${me.$options.filters.formatData(col.filter.to, {
							formatType: col.formatType,
						})}`;
					} else {
						valueText = me.$options.filters.formatData(col.filter.value, {
							formatType: col.formatType,
						});
					}
					break;
				case me.$ms.enum.FormatType.Number:
					valueText = me.$options.filters.formatData(col.filter.value, {
						formatType: col.formatType,
						maxDigits: 2,
					});
					break;
				default:
					valueText = col.filter.value;
					break;
			}
			//Nếu TH là enum mà giá trị chọn lọc là tất cả thì sẽ không xử lý
			if (isFilterAll) {
				let check = me.filterHeaders.find((i) => i.FieldName == col.dataField);
				if (check != null) {
					me.removeFilterItem(check);
				}
			} else {
				me.processFilterHeader(
					col.dataField,
					col.filter.operator,
					col.filter.value,
					valueText,
					col.filter.from,
					col.filter.to
				);
				let th = me.$refs.th.filter((x) => x.col.dataField == col.dataField);
				if (th && th.length > 0) {
					th[0].checkHideButtonHeaderFilter();
				}
			}
		},

		/**
		 * Xử lý thêm hoặc update giá trị vào FilterHeader
		 */
		processFilterHeader(
			fieldName,
			operator,
			value,
			valueText,
			from = null,
			to = null
		) {
			const me = this;
			let newFilter = {
				FieldName: fieldName,
				Operator: operator,
				Value: value,
				ValueText: valueText,
				FromDate: from,
				ToDate: to,
				Title: me.$t(`i18nComponent.HeaderOptionFilter.${fieldName}`),
			};
			//Kiểm tra đã tồn tại thì gán lại giá trị không thì sẽ thêm mới bộ lọc
			let check = me.filterHeaders.find((i) => i.FieldName == fieldName);
			if (check == null) {
				me.filterHeaders.push(newFilter);
			} else {
				check.Operator = operator;
				check.Value = value;
				check.ValueText = valueText;
				check.FromDate = from;
				check.ToDate = to;
			}
		},

		/**
		 * hàm bỏ lọc cột
		 */
		clearAllFilter() {
			let me = this;
			me.filterHeaders.forEach((item) => {
				if (
					!item.FormatType ||
					item.FormatType == me.$ms.enum.FormatType.Text ||
					item.FormatType == me.$ms.enum.FormatType.None
				) {
					item.Operator = me.$ms.enum.FilterOperator.Contains;
				} else {
					item.Operator = me.$ms.enum.FilterOperator.Equals;
				}
				let th = me.$refs.th.filter((x) => x.col.dataField == item.FieldName);
				if (th && th.length > 0) {
					th[0].col.filter.value = null;
					th[0].col.filter.operator = me.setOperatorDefault(
						th[0].col.formatType
					);
					th[0].col.hasActionFilter = false;
					th[0].checkHideButtonHeaderFilter();
				}
			});
			me.filterHeaders.removeAll();
			me.$emit('loadFilterHeader', null);
		},

		/**
		 * Set operator mặc định của các cột
		 */
		setOperatorDefault(formatType) {
			const me = this;
			if (formatType == me.$ms.enum.FormatType.Enum) {
				return me.$ms.enum.FilterOperator.In;
			} else if (formatType == me.$ms.enum.FormatType.EnumOne) {
				return me.$ms.enum.FilterOperator.Equals;
			} else if (
				formatType == me.$ms.enum.FormatType.Number ||
				formatType == me.$ms.enum.FormatType.Date
			) {
				return me.$ms.enum.FilterOperator.Equals;
			} else {
				return me.$ms.enum.FilterOperator.Contains;
			}
		},

		resetPageSize(pageSize, isLoadPage = true) {
			try {
				const me = this;
				me.pageSize = pageSize;
				me.$refs.pagination.setPageSize(pageSize);
				if (isLoadPage) {
					me.$refs.pagination.loadPageIndex(1);
				}
			} catch (ex) {
				console.log(ex);
			}
		},

		/**
		 * Hàm load lại tổng số trang ở trang hiện tại
		 * @author hvanh - 17.6.2024
		 */
		reloadCurrentPageSize(pageSize, isLoadPage = true) {
			try {
				const me = this;
				me.pageSize = pageSize || me.pageSize;
				me.$refs.pagination.setPageSize(pageSize);
				if (isLoadPage) {
					me.$refs.pagination.loadPageIndex(me.currentPage);
				}
			} catch (ex) {
				console.log(ex);
			}
		},
		handleAction(data) {
			const me = this;
			me.$emit('dataAction', data);
		},

		onDragChange() {
			const me = this;
			me.$emit('dragChange', me.datax);
		},
		/**
		 * Cập nhật lại trạng thái sort
		 * Chỉ áp dụng với mode sort server
		 */
		updateRemoteSortMode(mode) {
			const me = this;
			if (me.remoteSort) {
				me.remoteSortMode = mode;
			}
		},

		/**
		 * Hàm focus vào dòng theo index
		 * @param {Number} index - Index của dòng cần focus
		 */
		focusRow(index) {
			const me = this;
			if (!me.datax || index < 0) return;

			// Scroll tới dòng đó
			me.$nextTick(() => {
				if (me.$refs.tr && me.$refs.tr[index]) {
					const rowElement = me.$refs.tr[index];
					if (rowElement && rowElement.$el) {
						// Scroll vào vùng nhìn thấy
						// Sử dụng scrollIntoView của native DOM
						// block: 'nearest' để scroll vừa đủ thấy, 'center' để vào giữa
						rowElement.$el.scrollIntoView({});
					}
				}
			});
		},
	},
	data() {
		const me = this;
		return {
			//Data trong grid dùng để render
			datax: null,
			//Columns trong grid dùng để render
			columnx: [],
			//Mode cho phép copy dữ liệu hay không thực hiện với các event kéo thả cột,độ rộng,...
			isResizeActive: false,
			//Trang hiện tại
			currentPage: 1,
			//Số bản ghi trên 1 trang
			pageSize: me.$ms.commonFunc.getTakePageSize(),
			//Dòng đang được chọn
			rowSelected: {},
			//Kiểm tra data đã được load hay chưa
			dataLoaded: false,
			hasScroll: false,
			isScrollLeft: false,
			layoutId: '',
			/**
			 * Dữ liệu tích chọn của nhiều trang danh sách các object
			 * {pageIndex : 0, datax : []}
			 */
			dataAll: [],
			//Filter trong grid dùng để render
			filterHeaders: [],

			resizingColumn: null, // Cột hiện đang được resize
			startX: 0, // Vị trí chuột ban đầu
			startWidth: 0, // Độ rộng cột ban đầu
			colCurrentResize: null, // Cột hiện tại đang resize
			remoteSortMode: 0, //Mode sort hiện tại (none: 0, desc: 1, asc: 2) chỉ áp dụng với hình thức sort server
			isScreenMall: this.$ms.commonFunc.checkSmallScreen(),
		};
	},
	beforeDestroy() {
		const me = this;
		document.removeEventListener('click', me.clickOutGrid);
		window.removeEventListener('resize', me.onResize);
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msGridViewer.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msGridViewer.scss';
}
.multiple-cell-widget {
	position: sticky;
	left: 35px;
}
.icon-attachfile {
	padding: 0px !important;
}

.text-orgempty-setting {
	color: #bec5d2;
	font-size: 14px;
	width: 170px;
}

.data-field {
	min-width: 100px;
}
.item-filter {
	max-width: 100%;
}
.icon-area {
	display: flex;
	justify-content: center;
	align-items: center;
}
.text-nondata-area {
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	line-height: 18px;
}
</style>
